import { logAction, useRelodeReducer, useSnackMiddleware } from "@relode/core";
import * as React from "react";

import {
    ClientPublicMarketResearchActions,
    useClientPublicMarketResearchActions,
} from "./clientPublicMarketResearchActions";
import {
    clientPublicMarketResearchReducer,
} from "./clientPublicMarketResearchReducer";
import {
    useClientPublicMarketResearchSearchHandlers,
} from "./clientPublicMarketResearchSearchHandlers";
import {
    ClientPublicMarketResearchState,
    defaultClientPublicMarketResearchState,
} from "./clientPublicMarketResearchState";

export type ClientPublicMarketResearchContextType = [
    ClientPublicMarketResearchState,
    ClientPublicMarketResearchActions
];

export const ClientPublicMarketResearchContext =
    React.createContext<ClientPublicMarketResearchContextType>(undefined);

export const ClientPublicMarketResearchProvider = (props: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = useRelodeReducer(
        clientPublicMarketResearchReducer,
        defaultClientPublicMarketResearchState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useClientPublicMarketResearchActions(state, dispatch);
    useClientPublicMarketResearchSearchHandlers(state, actions);

    const value = React.useMemo(
        () => [state, actions],
        [actions, state]
    ) as ClientPublicMarketResearchContextType;

    return (
        <ClientPublicMarketResearchContext.Provider value={value} {...props} />
    );
};

export const useClientPublicMarketResearchContext = () => {
    const context = React.useContext(ClientPublicMarketResearchContext);
    if (!context) {
        throw new Error(
            "useClientPublicMarketResearchContext must be used within an appropriate provider"
        );
    }
    return context;
};
